export interface ISchedule {
  type: string;
  argument: number;
  time: string;
}
